import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from "react";
import { getAuthToken } from "../auth";
import { SaleorContext } from "./context";
export function useSaleorClient() {
  var saleor = React.useContext(SaleorContext);

  if (!saleor) {
    throw new Error("Could not find saleor's apollo client in the context. " + "Did you forget to wrap the root component in a <SaleorProvider>?");
  }

  return saleor;
}
export var useAuth = function useAuth(stateChangeCallback) {
  var _React$useState = React.useState(!!getAuthToken()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      authenticated = _React$useState2[0],
      setAuthenticated = _React$useState2[1];

  var eventHandler = function eventHandler() {
    var newState = !!getAuthToken();

    if (stateChangeCallback && authenticated !== newState) {
      stateChangeCallback(newState);
    }

    setAuthenticated(newState);
  };

  React.useEffect(function () {
    addEventListener("auth", eventHandler);
    return function () {
      removeEventListener("auth", eventHandler);
    };
  }, [authenticated]);
  return {
    authenticated: authenticated
  };
};